export const LOAD_INITIAL_DATA_REQUEST = 'LOAD_INITIAL_DATA_REQUEST';
export const LOAD_INITIAL_DATA_SUCCESS = 'LOAD_INITIAL_DATA_SUCCESS';
export const LOAD_INITIAL_DATA_FAILURE = 'LOAD_INITIAL_DATA_FAILURE';

export const SIGN_OUT_REQUEST = 'SIGN_OUT_REQUEST';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'SIGN_OUT_FAILURE';
